import axios, { AxiosResponse } from "axios";
import { kore_url } from "./index";

interface ArchiveInterface {
    archivedAt?: string;
    entity: string;
    doc?: {
        firstName?: string;
        lastName?: string;
        username?: string;
        externId?: string;
        id?: string;
    }
}

export default{
    getFullArchList: async (
        token: string,
        scope?: string,
    ) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        return await axios
        .get(
            kore_url +
            `/api/v4/archive/?${scope}select=doc,entity,archivedAt`,
            config
        )
        .then((archivedList) => {
            return archivedList.data;
        })
        .catch((err) => {
            return err;
        }); 
    },
    unarchiveById: async (
        userId: string,
        token: string,
    ) => {
        const config = {
            method: "POST",
            url: `${kore_url}/api/v4/archive/${userId}`,
            headers: { Authorization: `Bearer ${token}` }
        };
        return axios(config).then((newCoordinator: AxiosResponse) => {
            return newCoordinator.data;
        });
    }
};